import { EXAMTYPE } from "../submodules/enum/exam";
import { OVERSEA } from "../submodules/enum/type";

const makeYearOptions = () => {
  const year = [];
  for (let i = new Date().getFullYear(); i >= 1900; i--) {
    year.push({ label: i, value: i });
  }

  return year;
};
const makeDayOptions = () => {
  const day = [];
  for (let i = 1; i < 32; i++) {
    day.push({ label: i, value: i.toString().padStart(2, "0") });
  }

  return day;
};
const makeresidentialAreaOptions = () => {
  const areas = [
    { label: "서울", value: 1 },
    { label: "인천", value: 2 },
    { label: "대전", value: 3 },
    { label: "광주", value: 4 },
    { label: "대구", value: 5 },
    { label: "울산", value: 6 },
    { label: "부산", value: 7 },
    { label: "세종", value: 8 },
    { label: "경기", value: 9 },
    { label: "강원", value: 10 },
    { label: "충북", value: 11 },
    { label: "충남", value: 12 },
    { label: "전북", value: 13 },
    { label: "전남", value: 14 },
    { label: "경북", value: 15 },
    { label: "경남", value: 16 },
    { label: "제주", value: 17 },
  ];

  // return areas.map((area) => {
  //   return { label: area, value: area };
  // });

  return areas;
};

export const getArea = (areaCode) => {
  switch (areaCode) {
    case 1:
      return "서울";
    case 2:
      return "인천";
    case 3:
      return "대전";
    case 4:
      return "광주";
    case 5:
      return "대구";
    case 6:
      return "울산";
    case 7:
      return "부산";
    case 8:
      return "세종";
    case 9:
      return "경기";
    case 10:
      return "강원";
    case 11:
      return "충북";
    case 12:
      return "충남";
    case 13:
      return "전북";
    case 14:
      return "전남";
    case 15:
      return "경북";
    case 16:
      return "경남";
    case 17:
      return "제주";
    default:
  }
};

export const getOverseasExperience = (code) => {
  switch (code) {
    case OVERSEA.ONE:
      return "6개월 미만";
    case OVERSEA.TWO:
      return "6개월 ~ 1년 미만";
    case OVERSEA.THR:
      return "1년 이상";
    default:
  }
};

// eslint-disable-next-line
const makeBankNameOptions = () => {
  const bankNames = [
    "산업은행",
    "기업은행",
    "국민은행",
    "외환은행",
    "수협은행",
    "농협은행",
    "농협은행(단위조합)",
    "우리은행",
    "SC제일은행",
    "씨티은행",
    "부산은행",
    "광주은행",
    "제주은행",
    "전북은행",
    "경남은행",
    "새마을금고",
    "신협은행",
    "우체국",
    "하나은행",
    "신한은행",
    "케이뱅크",
    "카카오뱅크",
  ];

  return bankNames.map((bankName) => {
    return { label: bankName, value: bankName };
  });
};

export const yearOptions = makeYearOptions();

export const monthOptions = [
  { label: "1", value: "01" },
  { label: "2", value: "02" },
  { label: "3", value: "03" },
  { label: "4", value: "04" },
  { label: "5", value: "05" },
  { label: "6", value: "06" },
  { label: "7", value: "07" },
  { label: "8", value: "08" },
  { label: "9", value: "09" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
];

export const dayOptions = makeDayOptions();
export const residentialAreaOptions = makeresidentialAreaOptions();
// export const bankNameOptions = makeBankNameOptions();

export const bankNameOptions = [
  { value: 1, label: "한국은행" },
  { value: 2, label: "산업은행" },
  { value: 3, label: "기업은행" },
  { value: 4, label: "국민은행" },
  { value: 7, label: "수협은행" },
  { value: 8, label: "수출입은행" },
  { value: 11, label: "NH농협은행" },
  { value: 12, label: "지역농축협" },
  { value: 20, label: "우리은행" },
  { value: 23, label: "SC제일은행" },
  { value: 27, label: "한국씨티은행" },
  { value: 31, label: "대구은행" },
  { value: 32, label: "부산은행" },
  { value: 34, label: "광주은행" },
  { value: 35, label: "제주은행" },
  { value: 37, label: "전북은행" },
  { value: 39, label: "경남은행" },
  { value: 41, label: "우리카드" },
  { value: 45, label: "새마을금고" },
  { value: 48, label: "신협" },
  { value: 50, label: "저축은행" },
  { value: 52, label: "모건스탠리은행" },
  { value: 54, label: "HSBC은행" },
  { value: 55, label: "도이치은행" },
  { value: 57, label: "제이피모간체이스은행" },
  { value: 58, label: "미즈호은행" },
  { value: 59, label: "엠유에프지은행" },
  { value: 60, label: "BOA은행" },
  { value: 61, label: "비엔피파리바은행" },
  { value: 62, label: "중국공상은행" },
  { value: 63, label: "중국은행" },
  { value: 64, label: "산림조합중앙회" },
  { value: 65, label: "대화은행" },
  { value: 66, label: "교통은행" },
  { value: 67, label: "중국건설은행" },
  { value: 71, label: "우체국" },
  { value: 76, label: "신용보증기금" },
  { value: 77, label: "기술보증기금" },
  { value: 81, label: "하나은행" },
  { value: 88, label: "신한은행" },
  { value: 89, label: "케이뱅크" },
  { value: 90, label: "카카오뱅크" },
  { value: 92, label: "토스뱅크" },
  { value: 94, label: "서울보증보험" },
];

export const getBankName = (bankCode) => {
  for (let bankName of bankNameOptions) {
    if (bankName.value === parseInt(bankCode)) {
      return bankName.label;
    }
  }
};

const makeHourOptions = () => {
  let hours = [];
  for (let i = 0; i <= 23; i++) {
    hours.push({ label: String(i), value: String(i) });
  }

  return hours;
};

const makeMinuteOptions = () => {
  let minute = [];
  for (let i = 0; i <= 59; i++) {
    minute.push({ label: String(i), value: String(i) });
  }

  return minute;
};

export const hourOptions = makeHourOptions();
export const minuteOptions = makeMinuteOptions();

export const stateOptions = [
  { value: "all", label: "전체" },
  { value: "finish", label: "완료" },
  // { value: "yet", label: "미완료" },
  { value: "retry", label: "재평가" },
];

export const questionOption = [
  { value: "1", label: "NIA" },
  { value: "3", label: "KOICA" },
];

const examtypeKeys = Object.keys(EXAMTYPE);
const examtypeList = [];
for (let i = 0; i < examtypeKeys.length; i++) {
  const k = examtypeKeys[i];
  const v = EXAMTYPE[k];
  // console.log(k, v)
  var examtypeKeysLabel = "";
  if (v === 1) examtypeKeysLabel = "코이카_테스트";

  if (v === 3) examtypeKeysLabel = "KHNP";
  if (v === 4) examtypeKeysLabel = "코이카_우즈벡";
  if (v === 5) examtypeKeysLabel = "코이카_인도네시아";
  if (v === 6) examtypeKeysLabel = "코이카_캄보디아";
  if (v === 7) examtypeKeysLabel = "코이카_태국어";
  if (v === 8) examtypeKeysLabel = "코이카_테툼어";
  if (v === 9) examtypeKeysLabel = "코이카_프랑스어";
  if (v === 10) examtypeKeysLabel = "코이카_라오스어";
  if (v === 11) examtypeKeysLabel = "코이카_네팔어";
  if (v === 12) examtypeKeysLabel = "코이카_따갈로그어";
  if (v === 13) examtypeKeysLabel = "코이카_러시아어";
  if (v === 14) examtypeKeysLabel = "코이카_몽골어";
  if (v === 15) examtypeKeysLabel = "코이카_미얀마어";
  if (v === 16) examtypeKeysLabel = "코이카_뱅골어";
  if (v === 17) examtypeKeysLabel = "코이카_베트남어";
  if (v === 18) examtypeKeysLabel = "코이카_스리랑카어";
  if (v === 19) examtypeKeysLabel = "코이카_스와힐리어";
  if (v === 20) examtypeKeysLabel = "코이카_스페인어";
  if (v === 21) examtypeKeysLabel = "코이카_아랍어";
  if (v === 22) examtypeKeysLabel = "코이카_암하라어";
  if (v === 23) examtypeKeysLabel = "코이카_영어";
  if (v === 24) examtypeKeysLabel = "코이카_데리자어";
  if (v === 25) examtypeKeysLabel = "코이카_키냐르완다어";
  examtypeList.push({ value: v, label: examtypeKeysLabel });
}
// console.log("EXAMTYPE", EXAMTYPE)
// console.log("examtypeList", examtypeList)
export const speakLanguageOption = examtypeList;

export const speakLanguageToKorean = (room_type) => {
  var room_typeToKorean = "";
  if (room_type === 1) room_typeToKorean = "코이카_테스트 말하기 평가";

  if (room_type == 3) room_typeToKorean = "코이카 말하기 평가";
  if (room_type == 4) room_typeToKorean = "우즈벡어 말하기 평가";
  if (room_type == 5) room_typeToKorean = "인도네시아어 말하기 평가";
  if (room_type == 6) room_typeToKorean = "캄보디아어 말하기 평가";
  if (room_type == 7) room_typeToKorean = "태국어 말하기 평가";
  if (room_type == 8) room_typeToKorean = "테툼어 말하기 평가";
  if (room_type == 9) room_typeToKorean = "프랑스어 말하기 평가";
  if (room_type == 10) room_typeToKorean = "라오스어 말하기 평가";
  if (room_type == 11) room_typeToKorean = "네팔어 말하기 평가";
  if (room_type == 12) room_typeToKorean = "따갈로그어 말하기 평가";
  if (room_type == 13) room_typeToKorean = "러시아어 말하기 평가";
  if (room_type == 14) room_typeToKorean = "몽골어 말하기 평가";
  if (room_type == 15) room_typeToKorean = "미얀마어 말하기 평가";
  if (room_type == 16) room_typeToKorean = "뱅골어 말하기 평가";
  if (room_type == 17) room_typeToKorean = "베트남어 말하기 평가";
  if (room_type == 18) room_typeToKorean = "스리랑카어 말하기 평가";
  if (room_type == 19) room_typeToKorean = "스와힐리어 말하기 평가";
  if (room_type == 20) room_typeToKorean = "스페인어 말하기 평가";
  if (room_type == 21) room_typeToKorean = "아랍어 말하기 평가";
  if (room_type == 22) room_typeToKorean = "암하라어 말하기 평가";
  if (room_type == 23) room_typeToKorean = "영어 말하기 평가";
  if (room_type == 24) room_typeToKorean = "데리자어 말하기 평가";
  if (room_type == 25) room_typeToKorean = "키냐르완다어 말하기 평가";
  return room_typeToKorean;
};

export const categoryOption = [
  { value: "1", label: "일반" },
  { value: "2", label: "KOICA" },
];

export const emailState = [
  { value: "1", label: "발송성공" },
  { value: "2", label: "발송실패" },
];

export const alignState = [
  { value: "1", label: "응시완료순" },
  { value: "2", label: "이름순" },
];

export const examTypeOptionIfCombo1 = [
  { value: "1", label: "Single" },
  { value: "2", label: "With roommate" },
  { value: "3", label: "With family" },
];

export const examTypeOptionIfCombo2 = [
  { value: "1", label: "Exercise" },
  { value: "2", label: "Culture" },
  { value: "3", label: "Social Media" },
  { value: "4", label: "Game" },
  { value: "5", label: "Art" },
  { value: "6", label: "Self-development" },
  { value: "7", label: "Take good car of oneself" },
];

export const examTypeOptionIfCombo3 = [
  { value: "1", label: "Student" },
  { value: "2", label: "No job" },
  { value: "3", label: "Employee" },
];

export const examTypeOptionIfCombo4 = [
  { value: "1", label: "Set 1" },
  { value: "2", label: "Set 2" },
  { value: "3", label: "Set 3" },
  { value: "4", label: "Set 4" },
];

export const examTypeOptionIfCombo5 = [
  { value: "1", label: "Politics/Foreign Affairs" },
  { value: "2", label: "Social Affairs" },
  { value: "3", label: "Economy" },
];

export const comboOption = [
  { value: "1", label: "combo1" },
  { value: "2", label: "combo2" },
  { value: "3", label: "combo3" },
  { value: "4", label: "combo4" },
  { value: "5", label: "combo5" },
];

export const languageOption = [
  { value: "ko", label: "한국어" },
  { value: "en", label: "영어" },
  { value: "ja", label: "일본어" },
  { value: "cn", label: "중국어" },
  { value: "es", label: "스페인어" },
  { value: "tw", label: "대만어" },
];

export const languageOptionReturn = (language) => {
  var result = "nyujin";
  if (language === "ko") {
    result = "nyujin";
  } else if (language === "en") {
    result = "danna";
  } else if (language === "ja") {
    result = "nnaomi";
  } else if (language === "cn") {
    result = "meimei";
  } else if (language === "es") {
    result = "jose";
  } else if (language === "tw") {
    result = "chiahua";
  }

  return result;
};
